// This file is only a template for actions.  Copy and paste this to your application's actions .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for actions is "[App Name]Actions.ts" i.e. UsersActions.ts, EntitlementActions.ts


import UserProfileConstants from './../constants/UserProfileConstants';
import UserProfileServices from './../services/UserProfileServices';
import UserProfileStore from './../stores/UserProfileStore';
import SystemActions from './../../../actions/SystemActions';
import SystemStore from './../../../stores/SystemStore';
import Dispatcher from './../../../flux/AppDispatcher';
var AppDispatcher = Dispatcher.get(UserProfileConstants.PROFILE_DISPATCHER);


function receiveData(data: IUserProfile) {
    AppDispatcher.dispatch({
        actionType: UserProfileConstants.PROFILE_GET,
        profile: data
    });
}

function receivePasswordSettings(data: IPasswordSettings) {
    AppDispatcher.dispatch({
        actionType: UserProfileConstants.PROFILE_GET_PASSWORD_SETTINGS,
        settings: data
    });
}

function sendValidationError(comp: string, error: IErrorMessageObject) {
    AppDispatcher.dispatch({
        actionType: UserProfileConstants.PROFILE_VALIDATION_ERROR,
        messageObj: error,
        component: comp
    });
}

var UserProfileActions = {
    getProfile(callback: any, errorCallback: any, ignoreDefaultError?: boolean) {

        UserProfileServices.getProfile(function (data) {
            if (callback !== 'undefined' && callback != null) {
                callback();
            }
            receiveData(data);
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        }, ignoreDefaultError);
    },

    getPasswordSettings(callback: any, errorCallback: any) {
        UserProfileServices.getPasswordSettings(function (data) {
            if (callback !== 'undefined' && callback != null) {
                callback();
            }
            receivePasswordSettings(data);
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    },

    editCurrentObject(comp: string, key: string, value: any) {
        AppDispatcher.dispatch({
            actionType: UserProfileConstants.PROFILE_UPDATE_OBJECT,
            component: comp,
            key: key,
            value: value
        });
    },

    cancelChanges() {
        AppDispatcher.dispatch({
            actionType: UserProfileConstants.PROFILE_CANCEL_CHANGES
        });
    },

    updateProfile(profile: IUserProfile, callback?: any, errorCallback?: any) {
        if (!SystemStore.isActionInProgress(UserProfileConstants.PROFILE_UPDATE)) {
            SystemActions.PublicActions.beginAction(UserProfileConstants.PROFILE_UPDATE);

            UserProfileServices.editUser(profile,
                () => {
                    AppDispatcher.dispatch({
                        actionType: UserProfileConstants.PROFILE_UPDATE
                    });

                    if (callback) {
                        callback();
                    }

                    SystemActions.PublicActions.endAction(UserProfileConstants.PROFILE_UPDATE);
                },
                (error) => {
                    if (error.messageObj.propertyName) {
                        sendValidationError(UserProfileConstants.PROFILE_MAIN_PAGE, error.messageObj);
                    }

                    if (errorCallback) {
                        errorCallback(error);
                    }

                    SystemActions.PublicActions.endAction(UserProfileConstants.PROFILE_UPDATE);
                },
                function (error) {
                    return error.messageObj.propertyName ? true : false;
                });
        }
    },

    updatePassword(oldPassword: string, newPassword: string, callback: any, errorCallback?: any) {
        if (!SystemStore.isActionInProgress(UserProfileConstants.PROFILE_UPDATE_PASSWORD)) {
            SystemActions.PublicActions.beginAction(UserProfileConstants.PROFILE_UPDATE_PASSWORD);

            UserProfileServices.changePassword(oldPassword, newPassword,
                () => {
                    AppDispatcher.dispatch({
                        actionType: UserProfileConstants.PROFILE_UPDATE_PASSWORD_SUCCESS
                    });

                    callback();

                    SystemActions.PublicActions.endAction(UserProfileConstants.PROFILE_UPDATE_PASSWORD);
                },
                (error) => {
                    if (errorCallback) {
                        errorCallback(error);
                    }

                    SystemActions.PublicActions.endAction(UserProfileConstants.PROFILE_UPDATE_PASSWORD);
                },
                function (error) {
                    return error.messageObj.propertyName ? true : false;
                });
        }
    }
}

export default UserProfileActions;